import {
  GET_ADDRESS_SUGGESTIONS,
  GET_ADDRESS_SUGGESTIONS_SUCCESS,
  GET_ADDRESS_SUGGESTIONS_FAIL,
  SET_ADDRESS,
  SET_USER_EMAIL,
  SET_ADDRESS_MODIFICATION,
  GET_PROPERTY_BY_ORDER_SUCCESS,
  GET_PROPERTY_BY_ORDER,
  POST_ASSESSMENT_DATA_SUCCESS,
  POST_ASSESSMENT_DATA,
  POST_ASSESSMENT_DATA_FAIL,
  GET_PROPERTY_BY_ORDER_FAIL,
  GET_PROPERTY_CURRENT_ASSESSMENT,
  GET_PROPERTY_CURRENT_ASSESSMENT_SUCCESS,
  GET_PROPERTY_CURRENT_ASSESSMENT_FAIL,
} from "../actionTypes";

const assessmentInitialState = {
  freeAssessmentFormValues: {},
  addressSuggestions: [],
  suggestionsFailed: false,
  error: null,
  loading: {
    addressSuggestions: false,
  },
  selectedAddress: {},
  customerEmail: "",
  globalLoading: false,
  uuid: null,
  orderPrice: null,
  orderBroker: null,
  orderDiscountCode: null,
  orderComputationResponse: null,
};

const assessmentReducer = (state = assessmentInitialState, action) => {
  switch (action.type) {
    case GET_ADDRESS_SUGGESTIONS:
      return {
        ...state,
        suggestionsFailed: false,
        loading: {
          ...state.loading,
          addressSuggestions: true,
        },
      };
    case GET_ADDRESS_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        addressSuggestions: action.payload.items,
        suggestionsFailed: false,
        loading: {
          ...state.loading,
          addressSuggestions: false,
        },
        error: null,
      };
    case GET_ADDRESS_SUGGESTIONS_FAIL:
      return {
        ...state,
        addressSuggestions: [],
        suggestionsFailed: true,
        loading: {
          ...state.loading,
          addressSuggestions: false,
        },
        error: action.payload ? action.payload.error : null,
      };
    case SET_ADDRESS:
      return {
        ...state,
        selectedAddress: action.payload.address,
        // Clear stale order context so a new address selection
        // isn't confused with a previous submission.
        uuid: null,
        customerEmail: "",
      };
    case SET_USER_EMAIL:
      return {
        ...state,
        customerEmail: action.payload.email,
      };
    case SET_ADDRESS_MODIFICATION:
      return {
        ...state,
        freeAssessmentFormValues: action.payload.values,
      };
    case GET_PROPERTY_BY_ORDER:
      return {
        ...state,
        globalLoading: true,
      };
    case GET_PROPERTY_BY_ORDER_SUCCESS:
      return {
        ...state,
        globalLoading: false,
        selectedAddress: action.payload.property,
        error: null,
        customerEmail: action.payload.email,
        uuid: action.payload.uuid,
        orderPrice: action.payload.price,
        orderBroker: action.payload.broker,
        orderDiscountCode: action.payload.discountCode,
      };
    case GET_PROPERTY_BY_ORDER_FAIL:
      return {
        ...state,
        error: action.payload.error,
        globalLoading: false,
      };
    case POST_ASSESSMENT_DATA:
      return {
        ...state,
        globalLoading: true,
      };
    case POST_ASSESSMENT_DATA_SUCCESS:
      const { isPreOrder, response } = action.payload;
      if (isPreOrder) {
        return {
          ...state,
          orderComputationResponse: { ...response.data },
          globalLoading: false,
        };
      }
      return {
        ...assessmentInitialState,
      };
    case POST_ASSESSMENT_DATA_FAIL:
      return {
        ...state,
        globalLoading: false,
        error: action.payload.error,
      };
    case GET_PROPERTY_CURRENT_ASSESSMENT:
      return {
        ...state,
        globalLoading: true,
        error: null,
      };
    case GET_PROPERTY_CURRENT_ASSESSMENT_SUCCESS:
      return {
        ...state,
        selectedAddress: {
          ...state.selectedAddress,
          appraisedData: action.payload,
        },
        globalLoading: false,
      };
    case GET_PROPERTY_CURRENT_ASSESSMENT_FAIL:
      return {
        ...state,
        globalLoading: false,
      };
    default:
      return state;
  }
};

export default assessmentReducer;
